<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>正版图书购买</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
		data() {
			return {
				infoText: `<h3><strong>正版法规标准与专业图书采购服务，支撑企业合规管理与许可评审</strong></h3><p>“正版图书购买”是特规通企业版面向特种设备从业单位和专业人员提供的正版法规标准与专业图书采购服务，聚焦企业在合规审查、许可评审、质量体系建设、项目投标、技术学习和人员培训中的正版资料需求，帮助用户便捷获取来源清晰、版权合规、可核验、可开票的法规标准与专业图书资源。</p><p>本服务由特规通合作伙伴北京品读文化发展有限公司提供图书销售与履约支持。北京品读文化深耕特种设备法规标准发行服务二十余年，是全国锅炉压力容器标准化技术委员会（SAC/TC262）法规标准图书指定服务窗口，长期服务特种设备设计、制造、安装、检验检测、使用管理、科研院所和监管相关单位，具备成熟的正版资源组织能力、供货能力和专业客服能力。</p><p>特规通通过与北京品读文化合作，将正版法规标准图书采购、在线查阅、电子标准管理、发票服务、正版来源说明和企业资料馆能力打通，为企业构建从“正版购买”到“合规使用”的完整闭环。</p><h3><strong>1）权威合作伙伴：深耕特种设备行业的专业发行服务机构</strong></h3><p>北京品读文化长期专注于特种设备法规标准图书发行与合规服务，依托全国锅炉压力容器标准化技术委员会相关资源优势，围绕特种设备行业高专业性、高合规要求和强标准依赖的特点，为行业用户提供法规标准、专业图书和合规资料采购服务。</p><p>作为特规通正版图书销售合作伙伴，北京品读文化已累计服务行业大量企业客户，覆盖锅炉、压力容器、压力管道、安全附件、压力管道元件、检验检测、设计制造、安装维保、使用管理等多个业务领域，能够更准确理解特种设备企业在许可评审、监督检查、体系审核和日常技术工作中的资料需求。</p><h3><strong>2）正版来源保障：出版社合作，渠道清晰，可追溯可核验</strong></h3><p>法规标准文件是企业开展合规管理和技术工作的基础依据。文件来源是否正规、版本是否准确、版权是否合规，直接关系到企业在许可评审、质量体系审核、项目投标和内部审查中的资料可信度。</p><p>北京品读文化与中国标准出版社、新华出版社、北京科学技术出版社等多家权威出版社建立长期合作关系，并提供 TSG、GB、NB、JB、HG、SH、DL 及相关团体标准、专业图书等多类型正版资源，帮助企业一站式获取特种设备行业常用法规标准与专业资料。</p><p>通过正版渠道采购，企业可以获得来源清晰、版权合规、信息可靠的法规标准文件，降低使用盗版资料、来源不明文件、失效版本或非正式文本带来的合规风险。</p><h3><strong>3）覆盖特种设备全流程：满足企业多场景资料需求</strong></h3><p>正版图书购买服务覆盖特种设备设计、制造、安装、改造、修理、检验检测、维护保养、使用管理、监督检查等全流程场景，支持企业围绕自身许可项目和业务范围采购所需法规标准与专业图书。</p><p>可采购资源包括：</p><ul><li>特种设备安全技术规范及配套法规文件；</li><li>国家标准、行业标准、团体标准及相关技术规范；</li><li>锅炉、压力容器、压力管道、安全附件等专业标准资料；</li><li>质量保证体系、许可评审、监督检查相关文件；</li><li>特种设备专业教材、培训教程和技术图书；</li><li>企业技术人员学习、培训、考证和能力提升资料。</li></ul><p>无论是企业建立法规标准清单、准备许可评审资料，还是开展设计审查、制造检验、体系建设、内部培训和项目投标，均可通过该服务获取正版、规范、可靠的资料支持。</p><h3><strong>4）纸质书与电子版并行：适配不同企业使用场景</strong></h3><p>平台支持纸质图书与电子版文件等多种采购形式，满足企业不同场景下的使用习惯和管理要求。</p><p>纸质书适合企业档案留存、评审现场查阅、会议讨论、培训发放和长期保存；电子版文件适合在线查阅、快速检索、跨岗位使用和企业资料馆统一管理。</p><p>企业可根据内控要求、资料用途、岗位需求和预算安排灵活选择采购形式，实现“买得到、查得快、用得上、管得住”。</p><h3><strong>5）开票与履约服务：支持企业规范采购和审计留档</strong></h3><p>正版图书购买服务支持开具正规发票，便于企业采购入账、费用报销、审计留档和合规管理。对于企业批量采购、专项采购或许可评审资料准备需求，平台可提供专业客服对接，协助企业完成书目确认、价格咨询、订单处理、发票开具和配送服务。</p><p>通过专业化履约服务，企业可以减少自行查找版本、核对来源、联系出版社和整理采购资料的工作量，让法规标准采购更加高效、省心、可靠。</p><h3><strong>6）电子标准与企业资料馆打通：购买后更好管理和使用</strong></h3><p>特规通企业版不仅提供正版图书购买入口，还将电子标准采购与企业资料馆能力打通。企业购买的电子法规标准可进入“企业已购电子标准”列表，长期保存，支持在线查阅和下载使用。</p><p>下载文件为带正版水印的 PDF，并进行加密保护，便于企业在授权范围内规范使用和内部管理。企业还可以将已购电子标准纳入法规标准收藏书单，并在 AI-行业大模型中按书单进行检索问答，使正版资料真正进入日常技术工作、合规审查和许可评审准备流程。</p><h3><strong>7）服务企业合规：让正版资料成为审核与评审依据</strong></h3><p>对于特种设备企业而言，法规标准资料不仅是技术人员查阅使用的工具，也是许可评审、质量体系审核、监督检查和内部合规管理中的重要支撑材料。</p><p>通过正版图书购买和企业资料馆联动，企业可以：</p><ul><li>建立与许可范围匹配的正版法规标准清单；</li><li>规范管理已购电子标准和专业图书资料；</li><li>形成清晰的正版来源和采购记录；</li><li>支持发票、正版说明、资料留档和审核核验；</li><li>在 AI 问答中基于正版资料进行依据查询和条款核对；</li><li>降低使用非正版、旧版本、来源不明文件带来的合规风险。</li></ul><p>这对于准备特种设备生产单位许可、鉴定评审、质量保证体系审核、项目投标和监督检查的企业尤为重要。</p><h3>8）核心价值：买正版、用正版、管正版、审得过</h3><p>“正版图书购买”不是普通图书销售入口，而是特规通企业版正版法规标准资源体系的重要组成部分。依托北京品读文化在特种设备法规标准发行服务领域的专业积累和出版社合作资源，特规通为企业提供更加可信、规范、便捷的正版资料采购与管理服务。</p><p>通过该模块，企业可以更好地实现：</p><ul><li>正版法规标准和专业图书一站式采购；</li><li>出版社合作渠道保障，来源清晰、版权合规；</li><li>支持发票和采购留痕，满足企业内控与审计要求；</li><li>纸质书与电子版灵活选择，适配多种使用场景；</li><li>电子标准纳入企业资料馆，便于长期管理和 AI 使用；</li><li>服务许可评审、体系审核、监督检查和企业合规管理。</li></ul><p>特规通企业版通过“正版购买 + 企业资料馆 + AI-行业大模型”的组合能力，帮助企业把法规标准资料从单次采购变成长期可管理、可核验、可使用的合规资产，为特种设备企业专业工作和合规经营提供稳定支撑。</p>`
			};
		}
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		min-height: calc(100vh - 120px);
		h3 {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;
		.topbox {
			color: #94a3b8;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
	.info-content {
		padding: 0 30px;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}

	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>
